import styled from 'styled-components';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import COLORS from '../../../common/styles/color-pallete';

export const HistoryWrapper = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const EmptyHistory = styled.div`
  gap: 16px;
  border: 1px solid;
  background-color: ${COLORS.white};
  border-radius: 8px;
  padding: 24px 16px;
  border-color: ${COLORS.lightGrey};
  overflow-wrap: anywhere;

  .zeroReferBox {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  .emptyStaticText {
    line-height: 18px;
    font-size: 14px;
    align-items: center;
    font-weight: 400;
    text-align: center;
    color: ${COLORS.textLightGrey};
  }
`;

export const ReferStatusHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border: 1px solid;
  background-color: ${COLORS.white};
  border-radius: 8px;
  padding: 24px 16px;
  border-color: ${COLORS.lightGrey};

  .activityCard {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }

  .separationLine {
    border: 1px solid;
    border-color: ${COLORS.lightGrey};
  }

  .statusContainer {
    width: 438px;
    gap: 4px;
    display: flex;
    flex-direction: column;
  }

  .index {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .referDetails {
    display: flex;
    justify-content: space-between;
  }

  .currenStatus {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 16px;
    line-height: 26px;
    align-items: center;
    overflow-wrap: anywhere;
  }

  .status {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    overflow-wrap: anywhere;
    color: ${COLORS.textLightGrey};
  }

  .statusBox {
    display: flex;
    padding: 4px 12px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.textLightGrey};
    font-size: 12px;
    line-height: 12px;
    align-items: center;
    height: 20px;
    background-color: ${COLORS.borderGrey};
    border-radius: 100px;
    border: 1px solid;
    border-color: ${COLORS.lightShadedGrey};
  }
  .completed {
    background-color: ${COLORS.lightBrand};
    color: ${COLORS.textGrey};
  }
  .completedDescription {
    color: ${COLORS.lightGreen};
  }
  .sendReminderContainer {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 22px;
    cursor: pointer;
  }
  .alertBellIcon {
    width: 18px;
    height: 18px;
  }
  .sendReminderText {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 12px;
    line-height: 22px;
    color: ${COLORS.darkBlue};
    text-align: center;
  }
`;
